import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import {channels} from '@/config/channels';

export const constantRoutes = [
  {
    path: '/',
    name: 'Homepage',    
    component: () => import("@/pages/homepage"),
  },
  {
    path: '/article',
    name: 'Article',
    component: () => import("@/pages/article"),
  },
  {
    path: '/player',
    name: 'Player',
    component: () => import("@/pages/player"),
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import("@/pages/search"),
  },
  {
    path: '/empty',
    name: 'EmptyPage',
    component: () => import("@/pages/empty"),
  },
];

channels.forEach(element => {
  constantRoutes.push({
    path: element.path,
    name: element.alias,
    component: () => import("@/pages/"+element.component),
  });
});

constantRoutes.push({
  path:'*',
  redirect: '/'
});

export default new Router({
  mode: "history",
  routes: constantRoutes,  
});



// WEBPACK FOOTER //
// ./src/router/index.js